export interface ContentServiceConfig {
	baseUrl: string;
}

/**
 * Given the current environment, return the identity service config
 * @returns ContentServiceConfig object
 * @throws Error if the content service config is not set
 */
export function loadContentServiceConfig(): ContentServiceConfig {
	const { CONTENT_SERVICE } = process.env;

	if (!CONTENT_SERVICE) {
		throw new Error("CONTENT_SERVICE config is not set.");
	}

	return {
		baseUrl: CONTENT_SERVICE
	};
}
